<script>
import axios from 'axios'
import config from '@/config'
import { mapState } from 'vuex'
import stateConfig from '@/store/config'

export default {
  computed: {
    ...mapState(['userid', 'admin'])
  },
  watch: {
    userid: {
      immediate: true,
      handler(value) {
        if (this.admin && this.admin.adminid === value) return
        this.fetchData()
      }
    }
  },
  methods: {
    async fetchData() {
      try {
        const response = await axios.get('/api/admin/info', {
          baseURL: config.serverUrl
        })
        if (response.status !== 200) return
        const { data } = response.data
        this.$store.commit(stateConfig.SET_ADMIN, data)
      } catch (error) {
        console.error(error)
      }
    }
  },
  render() {
    return this.$scopedSlots.default(this.admin)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/providers/AdminProvider.vue